import I18N from '@leverege/i18n'
import { DataViewerModel } from '@leverege/molten/data-viewers'

import CycleAndWorkforceTrackingSupportDataViewer from './CycleAndWorkforceTrackingSupportDataViewer.js'
import EventsView from '../events/EventsView.jsx'
import EventsViewModel from '../events/EventsViewModel.js'

const { tf, tfIcon } = I18N.ns( 'tpi.dataViewers.LineStageGanttChart' )

export default {
  id : 'tpi.dataViewers.LineStageGanttChart',
  type : 'tpi.LineStageGanttChart',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : [ 'main', 'card' ],
  matches : { type : [ 'GroupDataViewer', 'ItemInfoDataViewer' ] },
  createSettings : ( props ) => {
    return EventsViewModel.create( {
      dataViewers : [ 
        DataViewerModel.create( 
          CycleAndWorkforceTrackingSupportDataViewer.type, 
          CycleAndWorkforceTrackingSupportDataViewer.createSettings( props ) )
      ],
      breakpoints : [ 'minWidth' ],
      useParent : false
    } )
  },
  component : EventsView,
  getDefaultCardContentOptions : { height : 'auto' }
}
